import { render, staticRenderFns } from "./IdoneitaAnamnesi.vue?vue&type=template&id=4547c027"
import script from "./IdoneitaAnamnesi.vue?vue&type=script&lang=js"
export * from "./IdoneitaAnamnesi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports